import React from "react";
import { useDispatch } from "react-redux";
import { setAuditDrawer } from "../../store/slices/homeSlice";

const SimpleRow = ({ data, index }) => {
  const dispatch = useDispatch();
  const bgColor = index % 2 === 0 ? "_bgGray90" : "_bgWhite";
  return (
    <div className={`simpleRow ${bgColor}`}>
      <p>{data.title}</p>
      {/* <span onClick={() => dispatch(setAuditDrawer(data.title))}>View</span> */}
      <span>View</span>
    </div>
  );
};

export default SimpleRow;
